if (!customElements.get('surcharge-code')) {
  customElements.define(
    'surcharge-code',
    class SurchargeCode extends HTMLElement {
      connectedCallback() {
        if (!this.initialized) {
          this.initialized = true;
          this.i18n = JSON.parse(this.querySelector('[data-surcharge-i18n]').textContent);
          this.variants = JSON.parse(this.querySelector('[data-surcharge-variants]').textContent);
          this.checkbox = this.querySelector('input[name="paint_match"]');
          this.fields = this.querySelector('.surcharge-code__fields');
          this.input = this.querySelector('input[name="paint_code"]');
          this.status = this.querySelector('.surcharge-code__status');
          this.hint = this.querySelector('[data-surcharge-hint]');
          this.upchargeVariantId = null;
          this.upchargeAmount = 500;
          this.adding = false;
          this.codeCommitted = false;
          this.lastCommittedCode = '';
          this.priceUpdateToken = 0;
          this.productNotAssigned = false;

          this.checkbox.autocomplete = 'off';
          this.checkbox.addEventListener('change', () => this.toggleFields());
          this.checkboxRow = this.querySelector('.surcharge-code__checkbox');
          this.checkboxRow.addEventListener('click', (event) => {
            if (event.target === this.checkbox) return;
            if (this.checkbox.checked) event.preventDefault();
          });
          this.boundResetPaintMatch = this.resetPaintMatch.bind(this);
          window.addEventListener('pageshow', this.boundResetPaintMatch);
          this.input.addEventListener('input', () => {
            this.setStatus('');
            this.codeCommitted = false;
            this.lastCommittedCode = '';
            this.priceUpdateToken += 1;
            this.setPriceUpdating(false);
            this.updateDisplayedPrice();
          });
          this.input.addEventListener('blur', () => this.commitPaintCode());
          this.input.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter') return;
            event.preventDefault();
            this.commitPaintCode();
          });

          document.addEventListener('submit', (event) => this.onFormSubmit(event), true);
          document.addEventListener('change', (event) => {
            if (event.target && event.target.matches && event.target.matches('[name="id"]')) {
              this.updateDisplayedPrice();
            }
          });

          this.getUpchargeVariantId('PAINT')
            .then((variantId) => {
              if (variantId || this.dataset.paintPending !== 'true') return;
              if (this.productNotAssigned) {
                this.hideLegacyPaintMatch(true);
                this.remove();
              }
            })
            .catch(() => {});
          this.resetPaintMatch();
          setTimeout(this.boundResetPaintMatch, 0);
        }
        if (this.boundResetPaintMatch) {
          window.addEventListener('pageshow', this.boundResetPaintMatch);
        }
        this.watchLegacyPaintMatch();
      }

      disconnectedCallback() {
        if (this.boundResetPaintMatch) {
          window.removeEventListener('pageshow', this.boundResetPaintMatch);
        }
        if (this.legacyPaintObserver) {
          this.legacyPaintObserver.disconnect();
          this.legacyPaintObserver = null;
        }
      }

      resetPaintMatch() {
        if (!this.checkbox) return;
        this.checkbox.checked = false;
        this.toggleFields();
      }

      watchLegacyPaintMatch() {
        this.hideLegacyPaintMatch();
        if (this.legacyPaintObserver) return;
        this.legacyPaintObserver = new MutationObserver(() => this.hideLegacyPaintMatch());
        this.legacyPaintObserver.observe(document.documentElement, { childList: true, subtree: true });
      }

      hideLegacyPaintMatch(restore = false) {
        document.querySelectorAll('ymq-option').forEach((option) => {
          const label = option.querySelector('.ymq_lable, .ymq-option-title');
          const text = ((label && label.textContent) || option.textContent || '').toLowerCase();
          if (!text.includes('paint match')) return;

          option.hidden = !restore;
          if (restore) {
            option.style.removeProperty('display');
          } else {
            option.style.setProperty('display', 'none', 'important');
          }
          option.querySelectorAll('input, textarea, select').forEach((field) => {
            if (restore) {
              field.disabled = false;
              if (field.dataset.surchargeLegacyName) {
                field.setAttribute('name', field.dataset.surchargeLegacyName);
                delete field.dataset.surchargeLegacyName;
              }
              return;
            }
            field.disabled = true;
            field.value = '';
            if (field.hasAttribute('name')) {
              field.dataset.surchargeLegacyName = field.getAttribute('name');
              field.removeAttribute('name');
            }
          });
        });
      }

      currentQuantity() {
        const qtyInput = document.querySelector('.product-form__quantity input[name="quantity"]');
        const qty = Number(qtyInput && qtyInput.value);
        return qty > 0 ? qty : 1;
      }

      currentProductPrice() {
        const idInput = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
        const variantId = idInput ? Number(idInput.value) : null;
        const match = this.variants.find((variant) => variant.id === variantId);
        return match ? match.price : Number(this.dataset.productPrice);
      }

      formatMoney(cents, compact) {
        const currency = this.dataset.currency || 'USD';
        const formatted = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: compact ? 0 : 2,
          maximumFractionDigits: compact ? 0 : 2,
        }).format(Number(cents) / 100);
        if (!compact && this.dataset.showCurrencyCode === 'true') {
          return formatted + ' ' + currency;
        }
        return formatted;
      }

      setStatus(message, type) {
        this.status.textContent = message || '';
        this.status.classList.toggle('is-error', type === 'error');
        this.status.classList.toggle('is-success', type === 'success');
        this.status.classList.toggle('is-updating', type === 'updating');
      }

      prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      priceRoot() {
        return document.querySelector('.product__info-container .price');
      }

      setPriceUpdating(isUpdating) {
        const price = this.priceRoot();
        if (!price) return;

        price.classList.toggle('is-surcharge-updating', Boolean(isUpdating));
        let spinner = price.querySelector('.surcharge-price-loader');

        if (isUpdating) {
          if (!spinner) {
            spinner = document.createElement('span');
            spinner.className = 'surcharge-price-loader';
            spinner.setAttribute('aria-hidden', 'true');
            price.prepend(spinner);
          }
          price.setAttribute('aria-busy', 'true');
          return;
        }

        if (spinner) spinner.remove();
        price.removeAttribute('aria-busy');
      }

      flashPrice() {
        const price = this.priceRoot();
        if (!price || this.prefersReducedMotion()) return;

        price.classList.remove('is-surcharge-updated');
        void price.offsetWidth;
        price.classList.add('is-surcharge-updated');
        const onEnd = (event) => {
          if (event.target !== price) return;
          price.classList.remove('is-surcharge-updated');
          price.removeEventListener('animationend', onEnd);
        };
        price.addEventListener('animationend', onEnd);
      }

      paintMatchEnabled() {
        return Boolean(this.checkbox && this.checkbox.checked);
      }

      paintCode() {
        if (!this.paintMatchEnabled()) return '';
        return (this.input.value || '').trim();
      }

      async commitPaintCode() {
        const paintCode = this.paintCode();

        if (!paintCode) {
          this.priceUpdateToken += 1;
          this.codeCommitted = false;
          this.lastCommittedCode = '';
          this.setPriceUpdating(false);
          this.setStatus('');
          this.updateDisplayedPrice();
          return;
        }

        if (paintCode === this.lastCommittedCode) return;

        const token = ++this.priceUpdateToken;
        this.codeCommitted = true;
        this.lastCommittedCode = paintCode;
        this.setPriceUpdating(true);
        this.setStatus(this.i18n.priceUpdating, 'updating');

        try {
          if (!this.upchargeVariantId) {
            await this.getUpchargeVariantId('PAINT');
          }
          if (!this.prefersReducedMotion()) {
            await new Promise((resolve) => setTimeout(resolve, 400));
          }
          if (token !== this.priceUpdateToken) return;
          this.updateDisplayedPrice({ highlight: true });
          this.setStatus(this.i18n.priceUpdated, 'success');
        } catch (error) {
          if (token !== this.priceUpdateToken) return;
          this.updateDisplayedPrice({ highlight: true });
          this.setStatus(this.i18n.priceUpdated, 'success');
        } finally {
          if (token === this.priceUpdateToken) this.setPriceUpdating(false);
        }
      }

      toggleFields() {
        const enabled = this.paintMatchEnabled();
        this.fields.hidden = !enabled;
        this.checkbox.setAttribute('aria-expanded', enabled ? 'true' : 'false');
        if (!enabled) {
          this.input.value = '';
          this.codeCommitted = false;
          this.lastCommittedCode = '';
          this.priceUpdateToken += 1;
          this.setPriceUpdating(false);
          this.setStatus('');
        }
        this.updateHint();
        this.updateDisplayedPrice();
      }

      updateHint() {
        if (!this.hint || !this.i18n.hint) return;
        const amount = this.formatMoney(Math.round(Number(this.upchargeAmount || 0) * 100), true);
        this.hint.textContent = this.i18n.hint.replace('__AMOUNT__', amount).replace('{{ amount }}', amount);
      }

      currentPriceNode() {
        const price = this.priceRoot();
        if (!price) return null;

        // Dawn always renders both regular and sale nodes. Without price--on-sale,
        // .price-item--sale is display:none, so writing to it leaves the visible price unchanged.
        if (price.classList.contains('price--on-sale')) {
          return price.querySelector('.price__sale .price-item--sale');
        }

        return (
          price.querySelector('.price__regular span.price-item--regular') ||
          price.querySelector('.price__regular .price-item--regular')
        );
      }

      updateDisplayedPrice({ highlight = false } = {}) {
        const node = this.currentPriceNode();
        if (!node) return;

        const productCents = this.currentProductPrice();
        if (node.dataset.surchargeApplied !== 'true') {
          node.dataset.surchargeBaseText = node.textContent.trim();
        }
        node.dataset.surchargeBaseCents = String(productCents);

        if (!this.codeCommitted || !this.paintCode()) {
          if (node.dataset.surchargeApplied === 'true') {
            node.textContent = node.dataset.surchargeBaseText;
            delete node.dataset.surchargeApplied;
          }
          return;
        }

        const surchargeCents = Math.round(Number(this.upchargeAmount || 0) * 100);
        const nextText = this.formatMoney(Number(node.dataset.surchargeBaseCents) + surchargeCents);
        node.textContent = nextText;
        node.dataset.surchargeApplied = 'true';
        if (highlight) this.flashPrice();
      }

      variantIdFrom(value) {
        if (value == null || value === '') return null;
        const text = String(value).trim();
        const gidMatch = text.match(/ProductVariant\/(\d+)/);
        if (gidMatch) return gidMatch[1];
        if (/^\d+$/.test(text)) return text;
        return null;
      }

      async getUpchargeVariantId(paintCode) {
        if (!paintCode || !String(paintCode).trim()) return null;
        if (this.upchargeVariantId) return this.upchargeVariantId;

        const response = await fetch(this.dataset.validateUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          cache: 'no-store',
          body: JSON.stringify({
            code: String(paintCode).trim(),
            productId: this.dataset.productId,
          }),
        });
        const data = await response.json();
        const message = data && data.message ? String(data.message) : '';
        this.productNotAssigned = /does not apply|no collections assigned/i.test(message);
        if (data && data.valid) {
          const variantId =
            this.variantIdFrom(data.surchargeVariantId) || this.variantIdFrom(data.surchargeVariantGid);
          if (variantId) {
            this.upchargeVariantId = variantId;
            if (data.surchargeAmount != null) this.upchargeAmount = Number(data.surchargeAmount);
            this.updateHint();
            if (this.codeCommitted && !this.priceRoot()?.classList.contains('is-surcharge-updating')) {
              this.updateDisplayedPrice({ highlight: true });
            }
            return this.upchargeVariantId;
          }
        }
        return null;
      }

      isSurchargeLine(item) {
        if (window.SurchargeCart) return window.SurchargeCart.isSurchargeLine(item);
        const properties = item.properties || {};
        return (
          properties._paint_upcharge === 'true' ||
          properties._surcharge === 'true' ||
          Boolean(properties['Surcharge Code'])
        );
      }

      cartSections(productForm) {
        const cart =
          (productForm && productForm.cart) ||
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        if (!cart || typeof cart.getSectionsToRender !== 'function') return [];
        return cart.getSectionsToRender().map((section) => section.id);
      }

      isAddError(result) {
        return Boolean(result && !Array.isArray(result) && result.status);
      }

      async addItems(items, sections) {
        const payload = { items: items };
        if (sections.length) {
          payload.sections = sections;
          payload.sections_url = window.location.pathname;
        }
        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        return addResponse.json();
      }

      async refreshCart(cartEl, result) {
        if (!cartEl) {
          window.location = window.routes.cart_url;
          return;
        }
        try {
          if (typeof publish === 'function') {
            await publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              cartData: result,
            });
          }
          if (result && result.sections && typeof cartEl.renderContents === 'function') {
            cartEl.renderContents(result);
          } else {
            const drawerItems = document.querySelector('cart-drawer-items');
            if (drawerItems && typeof drawerItems.onCartUpdate === 'function') {
              await drawerItems.onCartUpdate();
            }
            if (typeof cartEl.open === 'function') cartEl.open();
          }
          cartEl.classList.remove('is-empty');
        } catch (error) {
          if (typeof cartEl.open === 'function') cartEl.open();
        }
      }

      async onFormSubmit(event) {
        const form = event.target;
        if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
        if (form.closest('quick-add-modal') || form.closest('.quick-add')) return;
        if (this.adding) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        const paintCode = this.paintCode();
        if (!paintCode) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const productForm = form.closest('product-form');
        const submitButton = productForm && productForm.querySelector('[type="submit"]');
        const spinner = productForm && productForm.querySelector('.loading__spinner');
        if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

        this.adding = true;
        this.setStatus('');
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
        }
        if (spinner) spinner.classList.remove('hidden');

        try {
          const formData = new FormData(form);
          const visorVariantId = this.variantIdFrom(formData.get('id'));
          const quantity = Number(formData.get('quantity')) || this.currentQuantity();
          const visorItem = {
            id: visorVariantId,
            quantity: quantity,
            properties: { 'Paint code': paintCode },
          };
          const sellingPlan = formData.get('selling_plan');
          if (sellingPlan) visorItem.selling_plan = Number(sellingPlan);

          const items = [visorItem];
          const cart = await (await fetch('/cart.js')).json();
          const helper = window.SurchargeCart;
          const existingUpcharge = helper
            ? helper.surchargeLine(cart)
            : cart.items.find((item) => this.isSurchargeLine(item));

          if (!existingUpcharge) {
            const upchargeId = await this.getUpchargeVariantId(paintCode);
            if (upchargeId) {
              items.push({
                id: upchargeId,
                quantity: quantity,
                properties: helper
                  ? helper.surchargeProperties(cart, {
                      extraTitle: this.dataset.productTitle,
                      paintCode: paintCode,
                    })
                  : { _paint_upcharge: 'true', _paint_code: paintCode },
              });
            }
          }

          const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const sections = this.cartSections(productForm);
          let result = await this.addItems(items, sections);

          if (this.isAddError(result) && items.length > 1) {
            result = await this.addItems([visorItem], sections);
            if (!this.isAddError(result)) {
              const upchargeResult = await this.addItems([items[1]], sections);
              if (!this.isAddError(upchargeResult) && upchargeResult.sections) result = upchargeResult;
            }
          }

          if (this.isAddError(result)) {
            this.setStatus(result.description || result.message || this.i18n.addFailed, 'error');
            if (productForm && typeof productForm.handleErrorMessage === 'function') {
              productForm.handleErrorMessage(result.description || result.message);
            }
            return;
          }

          if (existingUpcharge) {
            const freshCart = await (await fetch('/cart.js')).json();
            const surcharge = helper
              ? helper.surchargeLine(freshCart)
              : freshCart.items.find((item) => this.isSurchargeLine(item));
            const linkedQty = helper
              ? helper.productQuantityForCode(freshCart)
              : surcharge
                ? surcharge.quantity + quantity
                : quantity;
            if (surcharge && (surcharge.quantity !== linkedQty || helper)) {
              const changeBody = { id: surcharge.key, quantity: linkedQty };
              if (helper) {
                changeBody.properties = helper.surchargeProperties(freshCart, {
                  paintCode: helper.paintCodeOf(surcharge),
                });
              }
              if (sections.length) {
                changeBody.sections = sections;
                changeBody.sections_url = window.location.pathname;
              }
              const changeResponse = await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(changeBody),
              });
              const changeResult = await changeResponse.json();
              if (changeResult && changeResult.sections) result = changeResult;
            }
          }

          await this.refreshCart(cartEl, result);
          this.resetPaintMatch();
        } catch (error) {
          const timedOut = error && error.name === 'AbortError';
          this.setStatus(timedOut ? this.i18n.timedOut : this.i18n.addFailed, 'error');
        } finally {
          this.adding = false;
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
        }
      }
    }
  );
}
